import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { CommonModule, DOCUMENT } from '@angular/common';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { ApiService } from 'src/app/services/api-data.service';
import { ToastrService } from 'ngx-toastr';
import { CommonService } from 'src/app/services/common.service';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { Location } from '@angular/common';
import { Subscription } from 'rxjs';
import { URLS } from 'src/app/_config/api.config';

@Component({
  selector: 'app-download-file',
  standalone: true,
  imports: [CommonModule,RouterModule],
  templateUrl: './download-file.component.html',
  styleUrls: ['./download-file.component.scss']
})
export class DownloadFileComponent implements OnInit {
  isDownloading = false;
  downloadProgress = 0;
  fileName = '';
  fileSize = '';
  fileUrl = ''; // This should be set based on your file location
  isLoading=false

  dataToBeEncrypted: any;
  decryptedData: any;

  file;
  id;
    private subscription: Subscription = new Subscription();

  constructor(
    private route: ActivatedRoute,
     private router: Router,
            private dataService: ApiService,
            private toastr: ToastrService,
            private activeRoute: ActivatedRoute,
            private _location: Location,
            public commonService: CommonService,
            @Inject(DOCUMENT) private document: any,
            @Inject(PLATFORM_ID) private platformId: Object,
            private activatedRoute: ActivatedRoute,
            private authService: AuthenticationService
  ) {}

  ngOnInit(): void {
    // You can get file info from route params or a service
    const data = this.activatedRoute.snapshot.paramMap.get('data');

        if (data) {
            //   this.token = params['token'];
            //   console.log('Extracted Token:', this.token);
            this.dataToBeEncrypted = data;
            if (this.dataToBeEncrypted.length > 1) {
                this.decryptedData = this.commonService.decryptData(this.dataToBeEncrypted);
                if (this.decryptedData) {
                   this.file=this.decryptedData.file;
                   this.fileName=this.file.split('/').pop() || '';
                   this.id=this.decryptedData.id;
                }
            }
        }
  }

  downloadFile() {
    if (this.isLoading)
      return;
         this.isLoading = true;
         const params = {
             // "formId": data.formId,
             // "status": data.status,
             "file": this.file,
             "id": this.id
         }
         this.subscription.add(
             this.dataService.post(URLS.zipDownload, params).subscribe(data => {
                 if (data['code'] == 200) {
                     this.isLoading = false;
                     this.toastr.success(data['message'], "Success");
                     this.commonService.downloadFile(data['data']);
                 } else {
                     this.isLoading = false;
                     this.toastr.error(data['message'], "Error");
                 }
             }, error => {
                 this.isLoading = false;
                 this.toastr.error(error['message'], "Error");
             })
         )
     }
}
